import React from "react"

import HashtagApi from "utils/api/hashtag"

export const HashtagContext = React.createContext({
  categories: [],
  fetchCategories: () => {},
})

export const HashtagContextProvider = ({ children }) => {
  const [categories, setCategories] = React.useState([])

  //
  // Fetch all of the available categories
  //

  const fetchCategories = React.useCallback(
    params => {
      return new Promise(async (resolve, reject) => {
        if (categories.length) return resolve(categories)

        try {
          let response = await HashtagApi.categories()
          setCategories(response.data.data)
          resolve(response.data.data)
        } catch (err) {
          reject(err)
        }
      })
    },
    [categories]
  )

  return <HashtagContext.Provider value={{ categories, fetchCategories }}>{children}</HashtagContext.Provider>
}
